// Tells the shared table toolkit which history entry it is filing view state
// under, so a sort, a filter and a grown "Show more" window all come back when an
// operator hits Back off a detail screen (`@recruiter/shared`'s `view-state.ts`
// explains the model, and `components/back-link.tsx` is the control that does the
// hop).
//
// The key is read the same way the router derives its own scroll-restoration key
// (`location.state.__TSR_key`, falling back to the href for an entry the router
// has not stamped, which is the very first one in a tab). Deriving it identically
// is what keeps the two halves in step: the scroll offset and the view it is an
// offset INTO are restored together or the restore is a lie.
//
// This lives in the app rather than in `@recruiter/shared` because the shared
// package must not depend on a router. It is the only router-aware piece of the
// mechanism.
import type { ReactNode } from "react";
import { useRouterState } from "@tanstack/react-router";
import { ViewStateEntryContext } from "@recruiter/shared";

export function ViewStateScope({ children }: { children: ReactNode }) {
  const entryKey = useRouterState({
    select: (state) => state.location.state.__TSR_key ?? state.location.href,
  });
  return (
    <ViewStateEntryContext.Provider value={entryKey}>{children}</ViewStateEntryContext.Provider>
  );
}
